import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs';
import { OrderQueries } from 'src/app/shared/types/get-query';
import { GraphQLService } from 'src/app/services/graph-ql.service';
import { MatDialog } from '@angular/material/dialog';
import * as _ from 'lodash';
import { FilterListComponent } from 'src/app/shared/components/filter-list/filter-list.component';
import { PhotographerFilterService } from 'src/app/services/filters/photographer-filter.service';
import { MutationQuery } from 'src/app/shared/types/mutation-query.enum';
import { AppService } from 'src/app/app.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { SnackbarType } from 'src/app/shared/components/snackbar/snackbar.component';
import { ChangeOrderStatusComponent } from 'src/app/shared/components/change-order-status/change-order-status.component';
import { Order, OrderStatus, OrderTypeEnum, OrderValitation } from 'src/app/components/company/models/new/order';
import { OrderMapper } from 'src/app/components/company/services/order-mapper';
import { Selectable } from 'src/app/shared/types/selectable.type';

@Component({
	selector: 'bt-photographer-order-detail-info',
	standalone: false,
	templateUrl: './photographer-order-detail-info.html',
	styleUrls: ['./photographer-order-detail-info.scss']
})
export class PhotographerOrderDetailInfoComponent {
	order: Order | null = null;
	orderValidation: OrderValitation = new OrderValitation();
	isNew: boolean = false;
	orderStatus = OrderStatus;
	loading: boolean = false;

	orderTypes: Selectable<{ id: OrderTypeEnum; name: string }>[] = [
		{ id: OrderTypeEnum.StillLife, name: 'Still-Life', selected: true },
		{ id: OrderTypeEnum.Dressed, name: 'On Model', selected: false },
		{ id: OrderTypeEnum.Complete, name: 'Complete', selected: false }
	];

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private appService: AppService,
		private utilitiesService: UtilitiesService,
		private graphQLService: GraphQLService,
		private dialog: MatDialog,
		private orderMapper: OrderMapper,
		private photographerService: PhotographerFilterService
	) {}

	ngOnInit(): void {
		this.route.parent?.params.subscribe((params) => {
			const orderId = params['orderId'];

			if (orderId != 'new') {
				this.getOrderInfo(Number(orderId));
				this.isNew = false;
			} else {
				this.order = new Order({
					creationDate: new Date()
				});
				this.isNew = true;
			}
		});
	}

	getOrderInfo(_orderId: number): void {
		this.loading = true;
		this.graphQLService
			.getData(OrderQueries.GET_ORDERS, { where: { orderId: { eq: _orderId } }, first: 1 })
			.pipe(map((res: any) => this.orderMapper.toOrder(res.data.orders.nodes[0])))
			.subscribe({
				next: (data: Order) => {
					this.order = data;
					console.log(this.order);

					this.orderTypes.forEach((type) => {
						type.selected = type.id === this.order?.orderType;
					});

					this.loading = false;
				},
				error: (err) => {
					this.utilitiesService.showSnackbar('Error during fetching order info', SnackbarType.Error);
					console.error(err);
					this.loading = false;
				}
			});
	}

	validate(): boolean {
		this.orderValidation.dueDate = this.order?.dueDate ? true : false;
		this.orderValidation.photographer = this.order?.photographer ? true : false;

		return _.every(Object.values(this.orderValidation));
	}

	openStatusModal(): void {
		const dialog = this.dialog.open(ChangeOrderStatusComponent, {
			data: { currentStatus: this.order?.status }
		});
		dialog.afterClosed().subscribe({
			next: (res) => {
				if (res) {
					if (this.order) {
						this.order.status = _.cloneDeep(res);
					}
				}
			}
		});
	}

	openEditPhotographerModal(): void {
		this.dialog
			.open(FilterListComponent<any>, {
				data: {
					title: 'Photographer',
					selected: this.order?.photographer ? [{ ...this.order.photographer, displayId: this.order.photographer.id }] : [],
					filterService: this.photographerService,
					singleSelection: true
				}
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						let photographer = res[0];

						if (this.order) {
							this.order.photographer = photographer;
						}
					}
				}
			});
	}
}
